export const agreeToTermsSelector = (state) => state.general.agreeToTerms;
